import { z } from 'zod'

export const searchValueAsText = (value: unknown): string =>
  typeof value === 'string' ? value : JSON.stringify(value)

export const rejectedValue = z
  .unknown()
  .refine((value) => value !== undefined)
  .transform(searchValueAsText)
  .pipe(z.string().min(1))

export const acceptedMonth = (value: number | string | undefined): number | undefined =>
  typeof value === 'number' ? value : undefined

export const isRejectedNumericSearchValue = (value: number | string | undefined): value is string =>
  typeof value === 'string' && value !== ''

export const isRejectedRoomValue = (value: string | undefined): boolean => value === ''

export const rejectedMonthMessage = (value: string): string =>
  `The month in the link (${value}) is not a valid month key, showing the default.`

export const rejectedMonthsMessage = (value: string): string =>
  `The window in the link (${value}) is not one of the offered windows, showing the default.`
